import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const OnboardingChooseGrade = lazy(() => import('../components/OnboardingChooseGrade'));
const SaveChildName = lazy(() => import('../components/SaveChildName') as any);
const SavePassword = lazy(() => import('../components/SavePassword') as any);

// Returns route JSX directly — must be called as {onboardingRoutes()} inside <Routes>,
// not rendered as <OnboardingRoutes />, because React Router validates element.type === Route.
const onboardingRoutes = () => (
	<>
		<Route path={FRONTEND_ROUTES.ONBOARDING_SAVE_CHILD_NAME} element={<SaveChildName />} />
		<Route path={FRONTEND_ROUTES.SAVE_CHILD_NAME} element={<SaveChildName isExistingUser />} />
		<Route path={FRONTEND_ROUTES.ONBOARDING_SAVE_PASSWORD} element={<SavePassword />} />
		<Route path={FRONTEND_ROUTES.ONBOARDING_CHOOSE_GRADE} element={<OnboardingChooseGrade />} />
		<Route
			path={FRONTEND_ROUTES.NEW_SCHOOL_YEAR}
			element={<OnboardingChooseGrade isSchoolNewYear />}
		/>
	</>
);

export default onboardingRoutes;
